import axios from "axios";


export const checkIsAdmin = async (token) => {

    let { data } = await axios.post(`https://zibaeslami.com/api/v1/check-admin`,token,{
        "accept":"application/json"
    })
    return data;

}
